/**
 * Dependencies
 */
import React, {Component} from 'react';
import { setResumeData } from "../../actions/resume";
import { connect } from 'react-redux';

/**
 * Components
 */
import Special from "../../components/Special/index";
import {removeDynamicFocus} from "../../components/Focus/utils";
import Utils from '../../utils/Utils';

class SpecialContainer extends  Component {

  componentWillUnmount() {
    removeDynamicFocus();
  }

  render() {
    const { match, user } = this.props;
    const specialName = match.params.name;
    const isMagicControlActive = Utils.getMagicControlKey();
    return (
      <div className="aff-container-vcard">
        <div className={isMagicControlActive ? "aaf-vcard-with-scroll" : "aaf-vcard"} style={{ paddingTop: "0px", height: "100%" }}>
          <Special specialName={specialName} setResume={this.props.setResumeData} user={user}/>
        </div>
      </div>
    )
  }
}


export default connect(null, { setResumeData })(SpecialContainer);



// WEBPACK FOOTER //
// ./src/containers/Special/index.jsx